import { useMemo } from 'react';
import { useQuizResults } from '@mentimeter/quiz';
import type { QuizResultData } from '@mentimeter/core-hooks';
import type { QuizChoiceStaticContent } from '@core-api/presentation/types/response';
import { usePresentationContext } from '../../legacy-context/presentationContext';
import { ViewOnlyPresentation } from './ViewOnlyPresentation';
import { useQuizChoicesPreviewResultsLegacy } from './hooks/use-quiz-choices-preview-results-legacy';

export const ViewOnlyPresentationDataHandler = () => {
  const {
    useQuestion,
    useConfig,
    InteractiveCanvasComponents,
    isPreviewResultsEnabled,
  } = usePresentationContext();
  const { enableAnimations } = useConfig();
  const { data = [] } = useQuizResults<QuizResultData>();
  const slide = useQuestion();
  const staticContent = slide.staticContent as QuizChoiceStaticContent;
  const interactiveContent = slide.interactiveContents[0]!;

  const transformedChoices = useMemo(() => {
    return interactiveContent.choices.map((choice, index) => ({
      id: choice.legacyChoiceId ?? index + 1,
      label: choice.title,
    }));
  }, [interactiveContent.choices]);

  const previewResults = useQuizChoicesPreviewResultsLegacy({
    isPreviewResultsEnabled,
    choices: transformedChoices,
  });

  const resultsToShow = isPreviewResultsEnabled ? previewResults : data;

  return (
    <ViewOnlyPresentation
      title={slide.title}
      styledTitle={staticContent.styledTitle as Record<string, unknown>}
      label={staticContent.label}
      description={interactiveContent.description}
      slideId={slide.slideId}
      choices={interactiveContent.choices}
      textSizeOffset={staticContent.textSizeOffset}
      shouldAnimate={enableAnimations}
      CanvasVisualizationArea={
        InteractiveCanvasComponents?.CanvasVisualizationArea
      }
      results={resultsToShow}
      isShowingPreviewResults={isPreviewResultsEnabled}
    />
  );
};
